import styled from 'styled-components';

const Title = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold};
  margin: auto 4px auto 0;
  max-width: 90px;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default Title;
